/**
 * @generated SignedSource<<b3322f9b82c1f5eb973e6074f647fe9c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type RawDataColumnFilter = {
  and?: RawDataColumnFilter | null | undefined;
  columnName: string;
  values: ReadonlyArray<string>;
};
export type DownloadRawDataButtonQuery$variables = {
  columnFilters?: ReadonlyArray<RawDataColumnFilter> | null | undefined;
  questionnaireId: string;
};
export type DownloadRawDataButtonQuery$data = {
  readonly rawData: {
    readonly path: string;
  } | null | undefined;
};
export type DownloadRawDataButtonQuery = {
  response: DownloadRawDataButtonQuery$data;
  variables: DownloadRawDataButtonQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "columnFilters"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "questionnaireId"
},
v2 = [
  {
    "kind": "Variable",
    "name": "columnFilters",
    "variableName": "columnFilters"
  },
  {
    "kind": "Literal",
    "name": "format",
    "value": "Csv"
  },
  {
    "kind": "Variable",
    "name": "questionnaireId",
    "variableName": "questionnaireId"
  },
  {
    "kind": "Literal",
    "name": "textReplacementFields",
    "value": [
      "teamName",
      "projectName",
      "surveyNumber"
    ]
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "path",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "DownloadRawDataButtonQuery",
    "selections": [
      {
        "alias": "rawData",
        "args": (v2/*: any*/),
        "concreteType": "DownloadInfo",
        "kind": "LinkedField",
        "name": "exportRawData",
        "plural": false,
        "selections": [
          (v3/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "DownloadRawDataButtonQuery",
    "selections": [
      {
        "alias": "rawData",
        "args": (v2/*: any*/),
        "concreteType": "DownloadInfo",
        "kind": "LinkedField",
        "name": "exportRawData",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "b07cdf9b65a1d7114f344d1fd56ee698",
    "id": null,
    "metadata": {},
    "name": "DownloadRawDataButtonQuery",
    "operationKind": "query",
    "text": "query DownloadRawDataButtonQuery(\n  $questionnaireId: ID!\n  $columnFilters: [RawDataColumnFilter!]\n) {\n  rawData: exportRawData(questionnaireId: $questionnaireId, textReplacementFields: [\"teamName\", \"projectName\", \"surveyNumber\"], columnFilters: $columnFilters, format: Csv) {\n    path\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "f1beab7bceef7232123d43c240983fa8";

export default node;
